import React from "react";
import { NextPage } from "next";

import TermsAndConditions from "scenes/TermsAndConditions";

const Index: NextPage = () => <TermsAndConditions activeTab="personal" />;

export default Index;
